/*eslint-disable*/
import api from '../'

class secretsOfCiceroGameItems {
    static getSecretsOfCiceroByRequest (params) {
        return api.axios.post('/secretsOfCiceroByRequest', params).then(response => response.data.words);
    }
}

export default secretsOfCiceroGameItems;
